









































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import RepositoryDetailBreadcrumb from '@/components/git/repositoryDetail/RepositoryDetailBreadcrumb.vue';
import RepositoryDetailHeader from '@/components/git/repositoryDetail/RepositoryDetailHeader.vue';

@Component({
  components: {
    AccountIcon,
    CommonButton,
    RepositoryDetailBreadcrumb,
    RepositoryDetailHeader,
  },
})
export default class PullRequestDetail extends Vue {
  private selectMenu: number = 0;
  private changeSelectMenu(selectMenu: number) {
    this.selectMenu = selectMenu;
  }
  private tab = 1;
  private changeSelected(index: number) {
    this.selectMenu = index;
  }
}
